import { render, staticRenderFns } from "./PanelistDashboardPage.vue?vue&type=template&id=123cc67f"
import script from "./PanelistDashboardPage.vue?vue&type=script&lang=ts"
export * from "./PanelistDashboardPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports